import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditCateringType = ({ show, onClose, cateringTypeData, id, onUpdated }) => {
  const [cateringType, setCateringType] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (show && cateringTypeData) {
      setCateringType(cateringTypeData.catering_type || '');
      setDescription(cateringTypeData.description || '');
      setErrors({});
    }
  }, [show, cateringTypeData]);

  const validate = () => {
    const newErrors = {};
    if (!cateringType.trim()) {
      newErrors.cateringType = 'Catering Type is required';
    }
    return newErrors;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await fetch(`${baseUrl}/cateringtype/update_catering/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          catering_type: cateringType,
          description,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update Catering Type');
      }

      toast.success('Catering Type updated successfully!');
      onClose();
      if (onUpdated) onUpdated();
    } catch (error) {
      console.error('Update Error:', error);
      toast.error('Failed to update Catering Type');
    }
  };

  return (
    <>
      <Modal show={show} size="md" onHide={onClose}>
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
            <h3 className="modal-title text-white">Update Catering Type</h3>
            <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
              <span className="text-white">×</span>
            </Button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleUpdate}>
              <div className="row">
                <div className="col-lg-12 mb-2">
                  <label className="text-black font-w500 fs-7">
                    Catering Type<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.cateringType ? 'is-invalid' : ''}`}
                    placeholder="Enter Catering Type"
                    value={cateringType}
                    onChange={(e) => setCateringType(e.target.value)}
                  />
                  {errors.cateringType && (
                    <div className="invalid-feedback" style={{ display: 'block' }}>
                      {errors.cateringType}
                    </div>
                  )}
                </div>
                <div className="col-lg-12 mb-2">
                  <label className="text-black font-w500 fs-7">Description</label>
                  <textarea
                    rows={4}
                    className="form-control h-auto"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                <Button type="submit" className="btn btn-sm btn-primary">
                  Update Catering Type
                  <i className="fas fa-angle-double-right ms-2"></i>
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default EditCateringType;
